import { buildCollection } from "@firecms/core";

export const backgroundStyleCollection = buildCollection({
  id: "background_style",
  name: "Background Style",
  path: "background_style",
  icon: "wallpaper",
  group: "Style",
  textSearchEnabled: true,
  properties: {
    name: {
      dataType: "string",
      name: "Name",
      validation: {
        required: true,
      },
    },
    background_image: {
      dataType: "string",
      name: "Background Image",
      storage: {
        storagePath: "/image/board/background",
        acceptedFiles: ["image/*"],
        maxSize: 1 * 1024 * 1024,
        fileName: "{rand}_{file}",
      },
      validation: {
        required: true,
      },
    },
    overlay_image: {
      dataType: "string",
      name: "Overlay Image (Optional)",
      storage: {
        storagePath: "/image/board/background",
        acceptedFiles: ["image/*"],
        maxSize: 1 * 1024 * 1024,
        fileName: "{rand}_{file}",
      },
    },
    dark_colored: {
      dataType: "boolean",
      name: "Dark Colored",
      defaultValue: true,
      validation: {
        required: true,
      },
    },
  },
});
